var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgProfile(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 20 21' }, props),
        React.createElement("path", { d: 'M10 .25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zm0 1.5a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm0 8.5c-5.469 0-8.76 3.291-9.741 9.635A.75.75 0 001 20.75h18a.75.75 0 00.741-.865c-.98-6.344-4.272-9.635-9.741-9.635zm.278 1.503c4.23.1 6.796 2.496 7.804 7.375l.023.122H1.894l.024-.122C2.948 14.143 5.605 11.75 10 11.75l.278.003z' })));
}
export default SvgProfile;
//# sourceMappingURL=Profile.js.map